import { Shimmer } from '@wartek-id/shimmer'

export default function MyAssessmentLoadingState() {
  const loadingStateData = new Array(3).fill('')

  return (
    <>
      {loadingStateData.map((_, idx) => (
        <div key={idx} className="p-4 shadow mb-3 bg-white rounded-md">
          <div className="flex mb-7">
            <Shimmer className="mr-3" width={32} height={32} rounded />
            <div className="flex-1">
              <Shimmer className="mb-3" width={186} height={12} />
              <Shimmer width={133} height={12} />
            </div>
          </div>
          <div className="flex">
            <div className="flex-1">
              <Shimmer width={96} height={12} />
            </div>
            <div>
              <Shimmer width={96} height={12} />
            </div>
          </div>
        </div>
      ))}
    </>
  )
}
